import Constant from '@/constant';
import soldocAPI from '@/api/soldoc';
import CampaignAuth from '@/utilities/campaignAuth';

export default {
    [Constant.SAVE_FILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveFile(payload.file)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    // console.log(JSON.stringify(err.response));
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
        
    },
    [Constant.CHECK_DIABETES_EXISTS]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.checkDiabetesExists(payload.name, payload.registration_number, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_TEMP_SAVE_DIABETES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchTempSaveDiabetes(payload.name, payload.registration_number, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_FIRST_DIABETES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveFirstDiabets(store.state.new_request_data, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_REVISIT_DIABETES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveRevisitDiabetes(store.state.revisit_request_data, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.TEMP_SAVE_DIABETES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.tempSaveDiabetes(store.state.files, store.state.body, payload.token)
                .then((response) => {
                    if(response.data.success === true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    //my page
    [Constant.SIGNIN_DIABETES_USER]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.signinDiabetesUser(payload.kakao_access_token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SIGNIN_AGREEMENT]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.signinAgreement(payload.agreement_service, payload.agreement_personal_info, payload.agreement_marketing, payload.token)
                .then((response) => {
                   
                    if(response.data.success == true)
                    {                  
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_USER_PROFILES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchDiabetesUserProfiles(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        store.commit(Constant.FETCH_DIABETES_USER_PROFILES, {
                            profiles: response.data.data
                        })
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_DIABETES_USER_CARD]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateDiabetesUserCard(store.state.cardchange_request_data, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_SETTLEMENT]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchDiabetesSettlement(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        store.commit(Constant.FETCH_DIABETES_SETTLEMENT, {
                            settlements: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_HISTORY]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchDiabetesHistory(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        store.commit(Constant.FETCH_DIABETES_HISTORY, {
                            diabetes_histories: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_DOCUMENT]: (store, payload) => {
        return new Promise((resolve, reject) => {
            
            soldocAPI.fetchDiabetesDocument(payload.reception_numbers, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        store.commit(Constant.FETCH_DIABETES_DOCUMENT, {
                            diabetes_documents: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_VOC_PAGE]: (store, payload) => {
  
         var pageno;
        if (typeof payload == "undefined" || typeof payload.pageno == "undefined")
            pageno = 0;
        else
            pageno = payload.pageno - 1;

        var pagesize = payload.pagesize;

        return new Promise((resolve, reject) => {
            soldocAPI.fetchDiabetesVocPage(pageno, pagesize, payload.sort)
                .then((response) => {
                    if (response.data.status == "success") {
                        store.commit(Constant.FETCH_DIABETES_VOC_PAGE, {
                            pageno: response.data.data.number,
                            pagesize: payload.pagesize,
                            totalcount: response.data.data.totalElements,
                            vocs: response.data.data.content,
                            allCount: response.data.count
                        });
                        resolve();
                    }
                    else
                    {
                        reject();
                    }
                })
                .catch((err) => {
                    reject(err);
                })
        })

    },
    [Constant.ADD_DIABETES_VOC]: (store, payload) => {
        return new Promise((resolve, reject) => {
            const token = CampaignAuth.getToken();
            if(token === null)
            {
                // 토큰이 없으면 바로 카카오 로그인
                CampaignAuth.relogin(true);
                reject();
                return;
            }

            soldocAPI.addDiabetesVoc(store.state.vocDiabetes, token)
                .then((response) => {
                    if(response.data.status == "success")
                    {            
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    // 인증 실패(401/502)는 에러 메시지 대신 카카오 로그인으로 이동
                    if(CampaignAuth.isAuthError(err))
                    {
                        CampaignAuth.relogin(true);
                        reject();
                        return;
                    }

                    if(err.response && err.response.data.status === "fail")
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_DIABETES_VOC]: (store, payload) => {
        return new Promise((resolve, reject) => {
            const token = CampaignAuth.getToken();
            if(token === null)
            {
                // 토큰이 없으면 바로 카카오 로그인
                CampaignAuth.relogin(false);
                reject();
                return;
            }

            soldocAPI.updateDiabetesVoc(store.state.vocDiabetes, token)
                .then((response) => {
                    if(response.data.status == "success")
                    {            
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    // 인증 실패(401/502)는 에러 메시지 대신 카카오 로그인으로 이동
                    if(CampaignAuth.isAuthError(err))
                    {
                        CampaignAuth.relogin(false);
                        reject();
                        return;
                    }

                    if(err.response && err.response.data.status === "fail")
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_DIABETES_USER_DELIVERY]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateDiabetesUserDelivery(payload.address, payload.detailAddress, payload.zipCode, payload.addressNickname, payload.addressDescription, payload.profileId, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    // v2
    [Constant.SIGNIN_KAKAO]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.signinKakao(payload.kakao_access_token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SIGNIN_AGREEMENT]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.signinAgreement(payload.agreement_service, payload.agreement_personal_info, payload.agreement_marketing, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                  
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_PROFILES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchProfiles(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        store.commit(Constant.FETCH_PROFILES, {
                            diabetes_profiles: response.data.data
                        })
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    reject();
                    // if(err.response.data.success === false)
                    // {
                    //     reject(err.response.data.data);
                    // }
                    // else 
                    // {
                    //     reject("고객센터에 문의 바랍니다");
                    // }
                })
        })
    },
    [Constant.FETCH_EXPECTED_DATE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchExpectedDate(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    reject();
                    // if(err.response.data.success === false)
                    // {
                    //     reject(err.response.data.data);
                    // }
                    // else 
                    // {
                    //     reject("고객센터에 문의 바랍니다");
                    // }
                })
        })
    },
    [Constant.ADD_DRAFT_PROFILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.addDraftProfile(store.state.draftProfile, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_DELEGATE_FALSE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveDelegateFalse(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_DELEGATE_WITH_ADDITION]: (store, payload) => {
        return new Promise((resolve, reject) => {

            soldocAPI.saveDelegateWithAddition(store.state.delegateWithAddition, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_CARD]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveCard(store.state.cardInfo, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.REGISTER_PROFILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.registerProfile(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_PROFILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchProfile(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        store.commit(Constant.FETCH_PROFILES, {
                            diabetes_profiles: response.data.data
                        })
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
             
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_PROFILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateProfile(payload.phoneNumber, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_CARD]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateCard(store.state.cardInfo, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.DELETE_CARD]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.deleteCard(payload.profile_id, payload.token)
                .then((response) => {
                    
                    if(response.status === 204)
                    {              
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_DELIVERY]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateDelivery(store.state.delivery, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_DELEGATE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveDelegate(store.state.delegateWithAddition, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_DELEGATE_ADDTION]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveDelegateAddition(store.state.delegateWithAddition.additional_info, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.status === 204)
                    {              
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_USAGE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchUsage(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        store.commit(Constant.FETCH_USAGE, {
                            diabetes_histories: response.data.data
                        })
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DOCUMENTS]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchDocuments(payload.reception_numbers, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        store.commit(Constant.FETCH_DIABETES_DOCUMENT, {
                            diabetes_documents: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_YEAR_TAX]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchYearTax(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        store.commit(Constant.FETCH_YEAR_TAX, {
                            settlements: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_INVITE_CODE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchInviteCode(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {
                        resolve(response.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_INVITE_FRIENDS]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchInviteFriends(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {
                        resolve(response.data);
                    }
                    else
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                    else
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.APPLY_INVITE_CODE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.applyInviteCode(payload.code, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject(err.response.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
}


// WEBPACK FOOTER //
// ./src/store/actions.js